interface ErrorObject {
  message: string;
}

function guard(payload: unknown): payload is ErrorObject {
  return payload !== null && typeof payload === 'object' && 'message' in payload;
}

abstract class ApplicationError extends Error {
  constructor(payload: unknown, defaultMsg: string) {
    super(guard(payload) ? payload.message : defaultMsg);
  }
}

class NetworkError extends ApplicationError {
  constructor() {
    super(null, 'ネットワークエラーが発生しました。');
  }
}

class BusinessCheckError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, 'チェックエラーが発生しました。');
  }
}

class UnauthorizedError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, '認証エラーが発生しました。ユーザーIDまたはパスワードが不正です。');
  }
}

class ForbiddenError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, '管理者によりアクセスが制限されています。');
  }
}

class ObjectNotFoundError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, '対象のデータが見つかりません。');
  }
}

class OptimisticLockError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, '他のユーザが更新したため登録できません。開きなおして確認してください。');
  }
}

class SystemError extends ApplicationError {
  constructor(payload: unknown) {
    super(payload, 'システムでエラーが発生しました。システムの管理者にお問い合わせしてください。');
  }
}

export {
  ApplicationError,
  BusinessCheckError,
  ForbiddenError,
  NetworkError,
  ObjectNotFoundError,
  OptimisticLockError,
  SystemError,
  UnauthorizedError,
};
export type { ErrorObject };
